var selectMultiple = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		$(target).find('[data-select-multiple]').on('change', function(e) {
			selectMultiple.setValue(e);
		});

		selectMultiple.initValue('[data-select-multiple]');

	},

	/** Functie die op basis van de waarde van de multi select in losse inputs zet  */
	setValue: function(e) {
		var values = $(e.target).val();
		var name = $(e.target).attr('name') || $(e.target).attr('data-original-name');
		$(e.target).attr('data-original-name', name).removeAttr('name');
		$('[data-select-multiple-group="' + name + '"]').remove();
		$.each(values, function(index) {
			var input = document.createElement('input');
			input.name = name + '[]';
			input.value = values[index];
			input.setAttribute('data-select-multiple-group', name);
			input.setAttribute('type', 'hidden');
			$(e.target).parent()[0].appendChild(input);
		});
	},


	/** Functie die de waarden van de multiple select toepast  */
	initValue: function(target) {
		$(target).each(function() {
			var values = $(this).data('select-multiple');
			$(this).val(values).trigger('change');
		});
	},

};

export default selectMultiple;
